import HeaderIcon from './HeaderIcon.component';

export const headerType = 'icon';
export default {
	headerRenderer: HeaderIcon,
};
